import FeedSearch from 'app/features/feed-search'
export default FeedSearch;